import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, ShieldCheck } from "lucide-react";
import { toast, Toaster } from "sonner";
import Navbar from "../components/Navbar";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/admin";
  const [email, setEmail] = useState("admin@lunchspot.app");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate(from, { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#F7F5F0]">
      <Toaster position="top-right" richColors />
      <Navbar />
      <div className="max-w-md mx-auto px-5 pt-20">
        <div className="bg-white rounded-2xl border border-[rgba(61,64,53,0.08)] p-8 shadow-sm">
          <div className="flex items-center gap-2 mb-6">
            <div className="w-10 h-10 rounded-xl bg-[#3D4035] text-white flex items-center justify-center">
              <ShieldCheck size={18} />
            </div>
            <div>
              <h1 className="font-heading text-2xl font-bold tracking-tight">Admin login</h1>
              <p className="text-sm text-[#6A6F5C]">Manage sources and extractions.</p>
            </div>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-[11px] uppercase tracking-[0.18em] font-semibold text-[#6A6F5C]">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 rounded-md bg-[#F7F5F0] border-[rgba(61,64,53,0.1)]"
                required
                data-testid="login-email"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-[11px] uppercase tracking-[0.18em] font-semibold text-[#6A6F5C]">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1.5 rounded-md bg-[#F7F5F0] border-[rgba(61,64,53,0.1)]"
                required
                data-testid="login-password"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full rounded-md bg-[#E07A5F] hover:bg-[#cf6b51] text-white font-medium h-11"
              data-testid="login-submit"
            >
              {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
              Sign in
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
